module.exports = __webpack_public_path__ + "img/lg_ring_g_i_0_0@3x.40237a1b.png";